import React, { useState } from "react"
import { db, auth } from "./firebase"
import {
  collection,
  addDoc,
  query,
  where,
  getDocs,
} from "firebase/firestore"

// 🚫 کلمات ممنوع
const bannedWords = ["sex", "fuck", "shit", "bitch"]

const containsBadWord = (text: string) => {
  return bannedWords.some((word) =>
    text.toLowerCase().includes(word)
  )
}

const Write = ({ navigate }: { navigate: any }) => {
  const [text, setText] = useState("")
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState("")
  const [success, setSuccess] = useState("")
  const [lastPostTime, setLastPostTime] = useState<number | null>(null)

  const handlePost = async () => {
    setError("")
    setSuccess("")

    if (!text.trim()) return setError("Write something first.")
    if (text.length < 5) return setError("Too short.")

    const now = Date.now()

    // ⛔ محدودیت 30 ثانیه
    if (lastPostTime && now - lastPostTime < 30000) {
      return setError("Wait before posting again.")
    }

    try {
      setLoading(true)

      // ⛔ محدودیت 3 پست در روز
      const oneDayAgo = now - 24 * 60 * 60 * 1000

      const q = query(
        collection(db, "posts"),
        where("userId", "==", auth.currentUser?.uid),
        where("createdAt", ">", oneDayAgo)
      )

      const snap = await getDocs(q)

      if (snap.size >= 3) {
        setError("Daily limit reached.")
        return
      }

      // 🔥 ثبت پست + moderation
      await addDoc(collection(db, "posts"), {
        text: text.trim(),
        createdAt: now,
        userId: auth.currentUser?.uid,
        likes: 0,
        likedBy: [],
        flagged: containsBadWord(text),
      })

      setText("")
      setLastPostTime(now)
      setSuccess("Posted")

      setTimeout(() => navigate("feed"), 800)
    } catch {
      setError("Error posting.")
    } finally {
      setLoading(false)
    }
  }

  return (
    <div style={{ maxWidth: 680, margin: "60px auto", padding: 24, color: "white" }}>
      <h2>Share your truth</h2>

      <textarea
        value={text}
        onChange={(e) => setText(e.target.value)}
        placeholder="Write what you can't say anywhere else..."
        style={{
          width: "100%",
          height: 160,
          padding: 16,
          borderRadius: 16,
          background: "rgba(255,255,255,0.05)",
          color: "white",
          marginBottom: 14,
        }}
      />

      <p style={{ fontSize: 13, opacity: 0.6, textAlign: "center" }}>
        100% anonymous. Login only prevents abuse.
      </p>

      <button onClick={handlePost} disabled={loading} style={{ width: "100%", padding: 16 }}>
        {loading ? "Posting..." : "Post"}
      </button>

      {error && <p style={{ color: "red" }}>{error}</p>}
      {success && <p style={{ color: "lightgreen" }}>{success}</p>}
    </div>
  )
}

export default Write